import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import { getFormValues, isPristine } from "redux-form";
import { showHideFastrade, fetchBanner, fetchTemplate } from "../../actions";
import { Grid, Header, Button, Icon } from "semantic-ui-react";
import "./trade.css";
import Loading from "../../app/loading";
import StageBanner from "./banner.js";
import BannerForm from "./form.js";
import Info from "./info.js";
import BuylistHeader from "../brand/header.js";
import { EditButton, CancelButton, DuplicateButton } from "../utils/buttons";
import { bannerPresets } from "./presets";

const Stage = ({ bannerForm, location, id, template, retailer, pristine }) => {
  const params = useParams();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user);
  const banner = useSelector((state) => state.banner);
  const showFastrade = useSelector((state) => state.fastrade);
  const [stage, setStage] = useState("banner");
  const [inEdit, setInEdit] = useState();
  const [formOrInfo, setFormOrInfo] = useState(<Info />);

  const bannerData = bannerForm || banner;

  useEffect(() => {
    dispatch(showHideFastrade(false));
    const path = location.pathname.split("/");
    const status = path.includes("edit")
      ? true
      : path.includes("new")
      ? true
      : false;
    setInEdit(status);
    return () => {
      dispatch(showHideFastrade(false));
      dispatch(fetchTemplate({}));
    };
  }, [dispatch, location.pathname]);

  useEffect(() => {
    if (template && !bannerData.headline) {
      dispatch(fetchBanner(bannerPresets));
      setInEdit(true);
    }
  }, [bannerData, template, dispatch]);

  useEffect(() => {
    if ((user && params["*"] === "edit") || (user && params["template"])) {
      setFormOrInfo(<BannerForm retailer={retailer} template={template} />);
    } else {
      setFormOrInfo(<Info />);
    }
  }, [params, user, retailer, template]);

  const handleClick = (comp) => {
    setStage(comp);
  };

  if (!bannerData) return <Loading />;

  return (
    <>
      <Grid padded>
        <Grid.Row className="bm-title-row">
          <Grid.Column computer={10} tablet={8} mobile={16}>
            <Header as="h3" content={bannerData.bannerTitle} />
          </Grid.Column>
          {user && (
            <Grid.Column computer={6} tablet={8} mobile={16}>
              {bannerData.key && !inEdit && (
                <DuplicateButton
                  data={bannerData}
                  location={location}
                  inUse={bannerData.currentUser}
                  size="mini"
                />
              )}
              {!inEdit && (
                <EditButton
                  id={id}
                  inUse={bannerData.currentUser}
                  size="mini"
                />
              )}
              {inEdit && (
                <Button
                  onClick={() => dispatch(showHideFastrade(!showFastrade))}
                  size="mini"
                  icon
                  labelPosition="right"
                >
                  {showFastrade ? (
                    <Icon name="angle up" />
                  ) : (
                    <Icon name="angle down" />
                  )}
                  Fastrade
                </Button>
              )}
              <CancelButton
                id={id}
                location={location}
                retailer={retailer}
                pristine={pristine}
                size="mini"
              />
            </Grid.Column>
          )}
        </Grid.Row>
        {bannerData.buylistHeader && bannerData.buylistHeader.path && (
          <Grid.Row>
            <Grid.Column width="16">
              <div className="banner-header">
                <Button size="tiny" onClick={(e) => handleClick("banner")}>
                  Banners
                </Button>{" "}
                <Button size="tiny" onClick={(e) => handleClick("header")}>
                  Header
                </Button>
              </div>
            </Grid.Column>
          </Grid.Row>
        )}
      </Grid>
      {stage === "banner" ? (
        <StageBanner banner={bannerData} retailer={retailer} />
      ) : (
        <BuylistHeader banner={bannerData} />
      )}
      {formOrInfo}
    </>
  );
};

export default connect((state) => ({
  bannerForm: getFormValues("bannerForm")(state),
  pristine: isPristine("bannerForm")(state),
}))(Stage);
